import DayPicker from './DayPicker'

export { default as DayPickerHeader } from './Header'

export default DayPicker
